import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import {
    getAmountOfTelcelPospago, executeTaggeo, getPaymentMethods,
    setCreditCardInfo, getCommissionInfo,
    setStartEventOnboardingIsOver,
    setTokenizationCard,
    setSnackBarSuccess,
    setLoadingTokenizationCard,
    getPhoneProfile,
} from '../../../store/actions';
import OfferTelcelWithoutLine from '../OfferTelcelWithoutLine';
import SelectInputClaroSocio from '../inputsClaroSocio/SelectInputClaroSocio';
import SelectCardClaroSocio from '../inputsClaroSocio/SelectCardClaroSocio';
import * as sdkclaro from "@claropay/claro-pay-sdk-v2";
import {
    OFFER_TELCEL_PAQUETE_AMIGO_SIN_LIMITE,
    OFFER_TELCEL_RECARGA,
    OFFER_TELCEL_POSPAGO,
    CREDIT_CLARO_PAY,
    ADVANCEMENT_CLARO_PAY,
    OFFER_TELCEL_PAQUETE_POSPAGO_EVENTUAL,
    REDIRECT,
    OFFER_TELCEL_PAQUETE_INTERNET_AMIGO,
    OFFER_TELCEL_PAQUETE_POR_TIEMPO,
    OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN,
    OPEN_NEW_MICROAPP,
    OFFER_TELCEL_PAQUETE_POSPAGO_MIXTO
} from '../../../constants';
import { 
    getCanShowCanCookiesValue, 
    selectPaymentServiceConf, 
    getPendingAmount,
    getTokenizationOnSelector,
    getTokenizationCardSelector,
    getCanRegisterEmailSelector,
    getLoadingTokenizationCardSelector
} from '../../../store/selectors/paymentsSelectors';
import CvvInputClaroSocio from '../inputsClaroSocio/CvvInputClaroSocio';
import { handleValidation } from '../inputsClaroSocio/utils';
import { validateUserAgent, getMessage, getRequirementsAdvancementClaroPay, getTypeEventValue, getTypeOfferValue, buttonMorePackagesConfigExist } from '../utils';
import { ClaroTooltip } from "@claropay/shared";
import ToolTipMiTelcel from '../TooltipMiTelcel';
import SelectInputTelcelContainer from '../inputsClaroSocio/SelectInputTelcelContainer';
import CvvInputTelcelContainer from '../inputsClaroSocio/CvvInputTelcelContainer';
import ButtonMiTelcel, { ButtonMiTelcelContenedorWhite } from '../../atoms/ButtonMiTelcel';
import SchedulePaymentButton from '../../molecules/schedulePaymentButton';
import { getMessengerService } from '../../../store/actions';
import SelectCardAnonimous from '../inputsClaroSocio/SelectCardClaroSocio/selectCardAnonimous';
import ModalCardHE from '../../molecules/ModalCardHE';
import { getHasDomiciliation } from '../../../store/actions/domiciliation';
import { formatCurrency } from '../utils';
import CarouselMegasTelcel from '../CarouselMegasTelcel';
import { buttonDomiciliationConfigExist } from '../utils';
import enviromentsRules from '../../../enviromentsRules';
import TokenizationCardContainer from '../../containers/TokenizationCardContainer';
import ModalCardOk from '../../molecules/ModalCardOk';
import ModalCardLoader from '../../molecules/ModalCardLoader';
import ModalRecurrente from '../../molecules/ModalRecurrente/ModalRecurrente';
import AdvanceMegas from '../../molecules/AdvanceMegas';

const ContainerRecurrent = styled.div`
    display: grid;
    grid-template-columns: 46px 1fr 24px;
    gap: 10px;
    align-items: center;
    .icon-package {
        width: 46px;
    }
    .title {
        font-family: Amx-Bold;
        font-size: 16px;
        color: #222;
        margin: 0px 0px 8px 0px;
    }
    .content {
        font-family: Amx-Regular;
        font-size: 14px;
        color: #222;
        margin: 0px;
        line-height: 22px;
    }
    .icon-arrow {
        width: 24px;
    }
`;

const Container = styled.div`
  width: 100%;
  background: ${props => props.background ? props.background : "#f6f6f6"};
  padding: ${props => props.withTokenization ? "0% 0% 0% 0%" : "5% 0% 0% 0%"};
  overflow: scroll;
`;

const CardInfoTelcel = styled.div`
    width: ${props => props.width ? props.width : '90%'};
    background: ${props => props.background ? props.background : '#fff'};
    margin: ${props => props.margin ? props.margin : '3% 3% 5% 3%'};
    box-shadow: ${props => props.boxShadow ? props.boxShadow : '1px 0px 0px rgb(1, 32, 36, 0.15),-1px 0px 0px rgb(1, 32, 36, 0.15),0px -1px 0px rgb(1, 32, 36, 0.15),0px 2px 2px rgb(1, 32, 36, 0.15)'};
    display: inline-block;
    padding: ${props => props.padding ? props.padding : '3% 2% 6% 2%'};
    border-radius: ${props => props.borderRadius ? props.borderRadius : '2%'};
`;

const Title = styled.p`
    font-size: ${props => props.fontSize ? props.fontSize : '14px'};
    font-family: ${props => props.fontFamily ? props.fontFamily : 'Amx-Regular'};
    color: ${props => props.color ? props.color : '#525252'};
    text-align: ${props => props.align ? props.align : 'left'};
    font-weight: ${props => props.weight ? props.weight : 'normal'};
`;

const Span = styled.span`
    font-size: ${props => props.size ? props.size : '14px'};
    font-family: ${props => props.fontFamily ? props.fontFamily : 'Amx-Regular'};
    color: ${props => props.color ? props.color : '#525252'};
    text-align: ${props => props.align ? props.align : 'left'};
    font-weight: ${props => props.weight ? props.weight : 'normal'};
`;

const DivIframeTelcel = styled.div`
    width: 100%;
`;

const HR = styled.hr`
    width: 94%;
`;

const Button = styled.button`
    border: ${props => props.isEnabled ? "1px solid black" : "1px solid #ccc"};
    border-radius: 25px;
    font-size: ${props => props.fontSize ? props.fontSize : "12px"};
    background:${props => props.isEnabled ? "#000" : "#ccc"};
    color: ${props => props.isEnabled ? "#fff" : "#999"};
    text-align: center;
    padding: 8px 15px;
    font-weight: ${props => props.weight ? props.weight : "normal"};
    margin: ${props => props.margin ? props.margin : "0%"};
    display : ${props => props.display ? props.display : "inline-block"};
    width : ${props => props.width ? props.width : "100%"};
`;

const DetailPospagoItem = styled.div`
    border-bottom: ${props => props.borderBottom};
    margin: ${props => props.margin};
    padding: ${props => props.padding};
`;

const ButtonsGridContainer = styled.div`
    display: grid;
    column-gap: ${props => props.isContainerTelcel ? (props.showDomicliationButton ? "16px" : "10px") : "15px"};
    grid-template-columns: ${props => props.isContainerTelcel ? (props.showDomicliationButton ? "repeat(2, 1fr)" : "auto") : "47.5% 47.5%"};
    padding: ${props => props.isContainerTelcel ? (!props.cvvIsVisible ? "3px 1.8% 10px" : "21px 1.8% 10px") : "18px 1.8% 0px 1.8%"};
`
const ButtonsContentPospagoGridContainer = styled.div`
    display: ${props => props.showDomicliationButton && props.showMorePackagesButton ? "grid" : props.showDomicliationButton || props.showMorePackagesButton? "" : "none" };
    column-gap: 15px;
    grid-template-columns: 47.5% 47.5%;
    padding: 18px 1.8% 0px 1.8%;
    // width: ${props => props.showDomicliationButton || props.showMorePackagesButton ? "" : "50%" };
    margin: ${props => props.showDomicliationButton || props.showMorePackagesButton ? "" : "auto" };

    grid-template-columns: ${props => props.isContainerTelcel ? "auto" : "47.5% 47.5%"};
    padding: ${props => props.isContainerTelcel ? "21px 1.8% 10px" : "18px 0% 0px 0%"};
`

class OfferTelcelWithLine extends Component {
    constructor(props) {
        super(props);
        const { 
            paymentMethods
        } = this.props

        const isAnonimous = this.props.isAnonimous || (
            this.props.isContainerTelcel && paymentMethods && paymentMethods.cardList.length === 0 && !paymentMethods.hasN2
        )
            ? true
            : false;

        let lineNumber = this.props.userInfo.msisdn.slice(-10);

        lineNumber = this.props.isAnonimous && this.props.paymentsConfig.msisdn
            ? this.props.paymentsConfig.msisdn.toString()
            : lineNumber;

        this.state = {
            lineNumber: lineNumber,
            configPospago: this.props.paymentsConfig.services[OFFER_TELCEL_POSPAGO],
            configPrepago: this.props.paymentsConfig.services[OFFER_TELCEL_RECARGA],
            inputConfigValues: this.props.paymentsConfig.services[OFFER_TELCEL_RECARGA]
                .serviceData.generic.elements,
            openSelectCard: false,
            isClaroPartner: this.props.paymentsConfig.isClaroPartner,
            valueSelectInput: "",
            mark: "",
            valueCardId: "",
            cvvValue: "",
            isValidCvv: false,
            openToolTip: false,
            isSetDefaultPaymentMethod: ((this.props.paymentMethods 
                && (
                    (this.props.paymentMethods.cardList && this.props.paymentMethods.cardList.length > 0)
                    || this.props.paymentMethods.hasN2
            ) && !isAnonimous) || this.props.addCardFormData.handleSetDefaultPaymentMethod) ? true : false,
            openHelpTooltipQuery: false,
            openHelpTooltipSlice: false,
            openHelpTooltipOptions: false,
            iframePostMessage: false,
            postMessageData: {},
            isAnonimous: isAnonimous,
            openSelectCardAnonimous: false,
            isOpenModalCardHE: false,
            tokenizationCardState: undefined,
            showTokenizationCard: false,
            cvvFromCardTokenization: false,
            openModalUpdateCard: false,
            updateWithTokenization: undefined,
            showModalRecurrent: false,
        }
    }

    componentDidMount() {
        const {
            getAmountOfTelcelPospago,
            lineTelcelInformation: { postpago, mixto },
            getMessengerService,
            getHasDomiciliation,
            referenceFromUrl,
            getPhoneProfile
        } = this.props
        this.sendTaggeo("View", postpago ? "Pospago" : "Prepago", false)
        const currentMicroappItemconfig = this.getCurrentMicroappItemConfig()
        const { lineNumber } = this.state
        getPhoneProfile(lineNumber);
        const { serviceId } = currentMicroappItemconfig.info
        if(postpago || mixto){
            getAmountOfTelcelPospago(lineNumber, serviceId);
            setTimeout(() => {
                getHasDomiciliation(referenceFromUrl || lineNumber, serviceId);
            }, 800);
        }

        if(localStorage.getItem("showTooltip") !== "false" && !this.props.isContainerTelcel){
            this.setState({openHelpTooltipQuery: true})  
        }

        if (this.props.creditCardInfo && this.props.creditCardInfo.value === ADVANCEMENT_CLARO_PAY) {
            this.props.setCreditCardInfo(undefined);
        }
        window.addEventListener(
            "message",
            (ev) => {
                const {messageType, informacionData} = ev.data;
                const {iframePostMessage} = this.state;
                if (
                    messageType === "informacion" && !iframePostMessage && 
                    ( informacionData.mensaje === "exito" || informacionData.mensaje === "vacio" )
                ){
                    this.setState({
                        iframePostMessage: true,
                        postMessageData:informacionData
                    })
                }
            }
        );
    }

    componentDidUpdate(prevProps) {
        if (this.props.tokenizationCard && this.props.tokenizationCard !== this.state.tokenizationCardState) {
            this.setState({
                tokenizationCardState: this.props.tokenizationCard,
            });
            if (this.props.tokenizationCard && this.props.tokenizationCard.result === "declined") {
                this.props.setTokenizationCard(undefined);
                this.setState({
                    showTokenizationCard: false,
                });
            }
        }
        if (this.props.isAnonimous !== prevProps.isAnonimous) {
            if (!this.props.isAnonimous) {
                const { paymentMethods } = this.props;
                if (
                    paymentMethods &&
                    paymentMethods.cardList &&
                    (
                        paymentMethods.cardList.length > 0 ||
                        paymentMethods.hasN2
                    )
                ) {
                    this.setState({ isAnonimous: false });
                    this.setDefaultPaymentMethod();
                }	
            }
        }
        if (this.props.paymentMethods !== prevProps.paymentMethods) {
            if (this.props.startEventOnboardingIsOver) {
                const { paymentMethods } = this.props;
                if (
                    paymentMethods &&
                    paymentMethods.cardList &&
                    (
                        paymentMethods.cardList.length > 0 ||
                        paymentMethods.hasN2
                    )
                ) {
                    this.setState({ isAnonimous: false });
                    this.setDefaultPaymentMethod();
                }	
                this.props.setStartEventOnboardingIsOver(false);
            }
            if (this.props.paymentMethods.cardList && this.props.paymentMethods.cardList.length > 0) {
                if(this.props.tokenizationCard){
                    console.debug("tokenizationCard in paymentMethods.cardList");
                    console.debug(this.props.tokenizationCard);
                    this.props.setTokenizationCard(undefined);
                    this.setState({
                        tokenizationCardState: this.props.tokenizationCard,
                    });
                    const cardAdd = this.props.paymentMethods.cardList.find((it) => it.cardId === this.props.tokenizationCard.cardId);
                    if(cardAdd && cardAdd.card){
                        this.setState({
                            isValidCvv: true,
                            cvvValue: this.props.tokenizationCard.cardCvv,
                            cvvFromCardTokenization: true,
                        });
                        this.handleCvvInputChange({
                            target: {
                                value: this.props.tokenizationCard.cardCvv,
                            }
                        })
                        setTimeout(() => {
                            this.handleInputClick("event", "cardId", {
                                value : cardAdd.cardId,
                                mark: cardAdd.card.mark,
                                type: cardAdd.card.type,
                                lastDigits: cardAdd.card.lastDigits,
                                update: false,
                            });
                        }, 300);
                    }
                }
            }
        }
    }

    validateActiveN2 = () => {
        const { activeN2, paymentsConfig: { sdkVersion } } = this.props
        return sdkVersion < "1.0.147" ? true : activeN2;
    };

    setDefaultPaymentMethod = () => {
        let cardInfo = {};
        let defaultItemPaymentMethod = [];
        const { creditCardInfo, paymentMethods } = this.props
        if (creditCardInfo && creditCardInfo.value != "agregar-targeta" && creditCardInfo.value != undefined) {
            cardInfo = creditCardInfo;
        } else {
            defaultItemPaymentMethod = paymentMethods.cardList.filter(
                (item) => item.isDefault != "0"
            );
            if (paymentMethods.hasN2 && this.validateActiveN2()) {
                if (defaultItemPaymentMethod[0]) {
                    cardInfo = {
                        value: defaultItemPaymentMethod[0].cardId,
                        mark: defaultItemPaymentMethod[0].card.mark,
                        type: defaultItemPaymentMethod[0].card.type,
                        lastDigits: defaultItemPaymentMethod[0].card.lastDigits,
                        update: false,
                    };
                } else {
                    cardInfo = {
                        value: "claro-pay",
                        mark: "999",
                        type: 0,
                        lastDigits: " ",
                        update: false,
                    };
                }
            } else {
                if (defaultItemPaymentMethod[0]) {
                    cardInfo = {
                        value: defaultItemPaymentMethod[0].cardId,
                        mark: defaultItemPaymentMethod[0].card.mark,
                        type: defaultItemPaymentMethod[0].card.type,
                        lastDigits: defaultItemPaymentMethod[0].card.lastDigits,
                        update: false,
                    };
                } else {
                    cardInfo = {
                        value: paymentMethods.cardList[0].cardId,
                        mark: paymentMethods.cardList[0].card.mark,
                        type: paymentMethods.cardList[0].card.type,
                        lastDigits: paymentMethods.cardList[0].card.lastDigits,
                        update: false,
                    };                   
                }
            }
        }
        this.handleInputClick(event, "cardId", cardInfo);
    };

    handleInputClick = (event, typeInput, cardInfo) => {
        const {
            lineTelcelInformation: { postpago },
            telcelPendingAmount,
            paymentsConfig: { sdkClaroVersion },
            trackId
        } = this.props

        const { isClaroPartner } = this.state
        this.props.setCreditCardInfo(cardInfo);
        this.setState({ openSelectCard: false });
        if(cardInfo.value !== "agregar-targeta" && cardInfo.value !== "claro-pay" &&
            cardInfo.value !== CREDIT_CLARO_PAY &&
            this.state.tokenizationCardState && this.state.tokenizationCardState.cardId
            && this.state.tokenizationCardState.cardId !== cardInfo.value
        ){
            this.setState({ cvvFromCardTokenization: false });
        }
        if (cardInfo.value == "agregar-targeta") {
            this.props.setSnackBarSuccess(undefined);
            this.setState({ valueSelectInput: "", mark: "", valueCardId: "", isValidCvv: false });
            console.debug("openWallet_______6 ya");
            console.debug(this.props.tokenizationOn)
            if(this.props.tokenizationOn){
                this.setAddCardFormDataHandler();
            } else {
                sdkclaro.getInstance().openWallet("openWallet");
            }
        } else {
            if (cardInfo.update == true) {
                this.setState({
                    openModalUpdateCard: true,
                    updateWithTokenization: cardInfo.card,
                })
            } else {
                this.setState({
                    valueSelectInput: cardInfo.lastDigits,
                    valueCardId: cardInfo.value,
                    mark: cardInfo.mark,
                    updateWithTokenization: undefined,
                });
                if (cardInfo.value === CREDIT_CLARO_PAY) {
                    this.setState({ isValidCvv: false, cvvValue: "" });
                } else {
                    const isClaroPay = cardInfo.value === "claro-pay" ? true : false;
                    const currentMicroappItemconfig = this.getCurrentMicroappItemConfig()

                    const amount = telcelPendingAmount || 1

                    this.props.getCommissionInfo(
                        currentMicroappItemconfig.info.serviceId,
                        "",
                        amount,
                        isClaroPay,
                        cardInfo.value,
                        sdkClaroVersion,
                        isClaroPartner,
                        trackId
                    );
                }
            }
        }
    };

    setAddCardFormDataHandler = () => {
        this.props.setTokenizationCard({
            open: true,
        });
        this.setState({
            showTokenizationCard: true,
        });
        console.log("ENTRO AQUI");
        this.props.setLoadingTokenizationCard(true);
    };

    closeTokenizationCard = (cardInfo) => {
        this.setState({
            showTokenizationCard: false,
        });
        const url = {
            app: "startEventNoClose",
            to : this.props.isContainerTelcel? "showContainerSnackBar" : this.props.canRegisterEmail? "showContainerSnackBar" : "showGenericSnackBack",
            parameters: JSON.stringify({show: "true",name:"highlightMB",cp:"CP0005",flow:"TokenizationCard",type:"positive"}),
        };
        const snackbarSaveCardSuccessParams = JSON.stringify(url)
        if(validateUserAgent() === "android"){
            if(this.props.isContainerTelcel || this.props.canRegisterEmail){
                this.props.setSnackBarSuccess({show: "true",name:"highlightMB",cp:"CP0005",flow:"TokenizationCard",type:"positive"});
            } else {
                sdkclaro.getInstance().openNative(snackbarSaveCardSuccessParams);
            }
        } else {
            sdkclaro.getInstance().openNative(snackbarSaveCardSuccessParams);
        }
        this.props.executeTaggeo({
            step: "Confirma tu información",
            action: "View snackbar Tarjeta guardada",
            eventName:"pay_service_or_tae",
			isAnonimous: this.props.isAnonimous,
            service: this.props.paymentsConfig && this.props.paymentsConfig.tagServiceId? 
            this.props.paymentsConfig.tagServiceId : "",
        });
        this.props.setTokenizationCard(cardInfo);
        const { isClaroPartner } = this.state;
        const currentMicroappItemconfig = this.getCurrentMicroappItemConfig()
        this.props.getPaymentMethods(currentMicroappItemconfig.info.serviceId, isClaroPartner);
    }

    handleBuyPackages = (
        action, 
        planType = null, 
        isRedirect = true, 
        ButtonPayValidate, 
        goToHTECH=false,
        offerConfigIndex=null
    ) => {
        if (ButtonPayValidate) {
            if (!offerConfigIndex || (offerConfigIndex && !this.props.isContainerTelcel)) {
                const offer = offerConfigIndex || OFFER_TELCEL_PAQUETE_AMIGO_SIN_LIMITE;
                this.sendTaggeo(action, planType, isRedirect, offer, goToHTECH)
            } else {
                if (isRedirect) {
                    this.redirect(offerConfigIndex)
                }
            }
        }
    }

    sendTaggeo = (action, planType = null, isRedirect = true, offerConfigIndex, goToHTECH=false) => {
        const { executeTaggeo, paymentsConfig, paymentMethods, isContainerTelcel } = this.props

        let params = {
            action: action,
            service: paymentsConfig.tagServiceId,
            plan_type: planType,
            step: "Pantalla principal",
            eventName: "telcel"
        }

        if (isContainerTelcel) {
            const typeFlow = (paymentMethods && paymentMethods.cardList.length === 0 && !paymentMethods.hasN2) || !paymentMethods
                ? "Usuario sin método" 
                : "Usuario con método";

            params = {...params, flow: typeFlow}
        }

        executeTaggeo(params);

        if (goToHTECH) {
            setTimeout(() => {
                window.location.href="https://padnet.telcel.com/portal/packages"
            }, 500);            
        }

        if (isRedirect) {
            this.redirect(offerConfigIndex)
        }
    }

    redirect = (offerConfigIndex) => {
        const {
            paymentsConfig,
            creditCardInfo,
            commissionRules,
            history,
            paymentMethods            
        } = this.props
        const {
            sdkClaroVersion,
            isClaroPartner,
            tagServiceId
        } = paymentsConfig
        const { lineNumber, cvvValue } = this.state
        const showCVV = commissionRules && commissionRules[0] ? commissionRules[0].payProcessor.showCVV : false;
        setTimeout(() => {
            history.push({
                pathname: '/menuTelcel',
                state: {
                    paymentMethods,
                    isContainerTelcel: this.props.isContainerTelcel,
                    sdkVersion: sdkClaroVersion,
                    paymentsConfig: paymentsConfig,
                    isClaroPartner: isClaroPartner,
                    serviceConfigIndex: offerConfigIndex,
                    tagServiceId: tagServiceId,
                    paramsNewOfferTelcel: {
                        line: lineNumber,
                        creditCardInfo: creditCardInfo,
                        cvv: { cvvValue: cvvValue, isRequiredCvv: showCVV },
                    }
                }
            })
        }, 500);
    }

    onSubmit = () => {
        const action = this.props.isContainerTelcel ? "Click Pagar" : "Click Pagar factura";
        this.sendTaggeo(action, "Pospago", true, OFFER_TELCEL_POSPAGO)
    };

    getCurrentMicroappItemConfig = () => {
        const { lineTelcelInformation: { postpago, mixto } } = this.props
        const { configPrepago, configPospago } = this.state
        return postpago || mixto ? configPospago.serviceData : configPrepago.serviceData
    }

    handleClickSelect = () => {
        if(this.props.tokenizationOn){
            const { isClaroPartner } = this.state
            const { getPaymentMethods } = this.props
            const currentMicroappItemconfig = this.getCurrentMicroappItemConfig()
            getPaymentMethods(currentMicroappItemconfig.info.serviceId, isClaroPartner);
            setTimeout(() => {
                this.setState({ openSelectCard: true });
            }, 300);
        } else {
            if (!this.props.isAnonimous) {
                const { isClaroPartner } = this.state
                const { getPaymentMethods } = this.props
                const currentMicroappItemconfig = this.getCurrentMicroappItemConfig()
                getPaymentMethods(currentMicroappItemconfig.info.serviceId, isClaroPartner);
                setTimeout(() => {
                    this.setState({ openSelectCard: true });
                }, 300);
            } else {
                this.setState({ openSelectCardAnonimous: true });
            }
        }
    }

    handleCvvInputChange = (e) => {
        const { value } = e.target
        const { inputConfigValues } = this.state
        const configCvvInput = inputConfigValues.find(perro => perro.id === "cvv")
        const inputValue = value.length > 4 ? value.substr(0, 4) : value
        this.setState({ cvvValue: inputValue });
        this.inputValidation(inputValue, configCvvInput, "isValidCvv");
    };

    inputValidation = (value, configInput, inputValid) => {
        const { constraints } = configInput
        if (constraints) {
            const cvvValidation = handleValidation(value, constraints[0]);
            this.setState({ [inputValid]: cvvValidation });
        } else {
            return true;
        }
    }

    handleClickTooltip = () => {
        this.setState({ openToolTip: true });
    }

    handleNextAction = (tooltipName) => {
        switch (tooltipName) {
            case "openHelpTooltipQuery":
                this.setState({
                    openHelpTooltipQuery: false, 
                    openHelpTooltipSlice: true
                })
                break;
            case "openHelpTooltipSlice":
                this.setState({
                    openHelpTooltipSlice: false,
                    openHelpTooltipOptions: true
                })
                break;
            case "openHelpTooltipOptions":
                localStorage.setItem("showTooltip", "false");
                this.setState({
                    openHelpTooltipOptions: false
                })
                break;
            default:
                break;
        }
    }

    handleDontShowAgain = (tooltipName) => {
        switch (tooltipName) {
            case "openHelpTooltipQuery":
                this.setState({
                    openHelpTooltipQuery: false
                })
                break;
            case "openHelpTooltipSlice":
                this.setState({
                    openHelpTooltipSlice: false
                })
                break;
            default:
                break;
        }
        localStorage.setItem("showTooltip", "false");
    }

    openAction = (e, action, typeOffer, typeEvent, microAppId ) => {
        e.preventDefault()
        const { paymentsConfig, executeTaggeo, planType, history, paramsNewOfferTelcel, step, event, paymentMethods, isContainerTelcel } = this.props
        const { 
            sdkClaroVersion, 
            isClaroPartner,
            tagServiceId
        } = paymentsConfig

        let params = {
            action: action,
            service : paymentsConfig.tagServiceId,
            plan_type : planType,
            step: step ? step :"Pantalla principal",
            eventName: event ? event : "telcel"
        }

        if (isContainerTelcel) {
            const typeFlow = paymentMethods && 
            paymentMethods.cardList && 
            paymentMethods.cardList.length > 0 && 
            paymentMethods.hasN2 
                ? "Usuario con método" 
                : "Usuario sin método";

            params = {...params, flow: typeFlow}

            if (this.props.quitPlanType) {
                delete params.plan_type
            }
        }

        executeTaggeo(params)
        const typeEventValue = getTypeEventValue(typeEvent)

        if(typeEventValue === REDIRECT){
            const typeOfferIndex =  getTypeOfferValue(typeOffer)
            const pathNameValue = typeOfferIndex == OFFER_TELCEL_PAQUETE_INTERNET_AMIGO ||
                typeOfferIndex == OFFER_TELCEL_PAQUETE_POR_TIEMPO ||
                typeOfferIndex == OFFER_TELCEL_PAQUETE_POSPAGO_EVENTUAL ||
                typeOfferIndex == OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN ? 
                (window.location.pathname === "/telcel-plans"?
                    "/telcel-plans/"+ typeOfferIndex:'/telcel-plans'
                )
                :
                '/menuTelcel'
            setTimeout(() => {
                    history.push({
                    pathname: pathNameValue,
                    state: {
                        sdkVersion: sdkClaroVersion,
                        paymentsConfig: paymentsConfig, 
                        isClaroPartner: isClaroPartner,
                        serviceConfigIndex: typeOfferIndex,
                        tagServiceId: tagServiceId,
                        paramsNewOfferTelcel: paramsNewOfferTelcel,
                        isContainerTelcel: this.props.isContainerTelcel
                    }
                })
            }, 500);
        } 
        if(typeEventValue === OPEN_NEW_MICROAPP ){
            const url = {
                app: "startEventNoClose",
                to : "openMicroApp",
                parameters: JSON.stringify({microAppId: microAppId}),
            };
            setTimeout(() => {
                sdkclaro.getInstance().openNative(
                    JSON.stringify(url),
                    () => {},
                    () => {},
                );
            }, 1000);
        }
    }

    showDomiciliationButton = (currentServiceConfig) => {
        const {generic: {elements}} = currentServiceConfig
        const {paymentStore} = this.props
        return buttonDomiciliationConfigExist(elements) && enviromentsRules(paymentStore, "showButtonDomiciliation")
    }

    showMorePackagesButton = (currentServiceConfig) => {
        const {generic: {elements}} = currentServiceConfig
        return buttonMorePackagesConfigExist(elements)
    }

    onclickUpdateCard = (event) => {
		this.setState({ openModalUpdateCard: false });
		if (event.target.textContent == "Actualizar ahora") {
			console.debug("openWallet_______7 ya");
			console.debug(this.props.tokenizationOn);
			if(this.props.tokenizationOn){
				this.setAddCardFormDataHandler();
			} else {
                console.log("openWallet-" + this.state.updateWithTokenization.cardId)
				sdkclaro.getInstance().openWallet("openWallet-" + this.state.updateWithTokenization.cardId);
			}
		}
	};

    openSuscripciones = (e) => {
        e.preventDefault();

        const { originParamValue = "", executeTaggeo } = this.props;

        let origen = originParamValue ? originParamValue.split(",") : "";
            origen = origen && origen[1] ? origen[1] : "";

        const params = {
            eventName: "subscriptions",
            seccion: "consulta megas",
            subseccion: "",
            origen: origen ? decodeURIComponent(atob(origen)) : "",
            clicBanners: 1,
            banners: [{
                type: "unico",
                position: 1,
                ubication: "medio",
                categoria: "consulta megas",
                nombreElemento: "tienes una recurrencia activa",
            }],
            pantalla: "tienes una recurrencia activa",
            trackAction: true,
        }

        // executeTaggeo(params, true);
        
        const parameters = { 
            microAppId: "suscripciones",
            originApp: "paymentsApp"
        };
        let url = {
            app: "startEventNoClose",
            to : "openMicroApp",
            parameters: JSON.stringify(parameters),
        };
        url = JSON.stringify(url);
        sdkclaro.getInstance().openNative(
           url,
            () => {},
            () => {},
        );
    }

    render() {
        const {
            paymentsConfig: { mainLogo, tagServiceId },
            telcelPendingAmount, lineTelcelInformation: { postpago, urlIframe, prepago, mixto },
            history, isLoadingGetPaymentMethods, paymentMethods,
            commissionRules,
            messages,
            isContainerTelcel,
            userInfo,
            isActiveButtonMoreDataMix,
            phoneProfile,
            loadingTokenizationCard
        } = this.props
        const {
            lineNumber, inputConfigValues, openSelectCard,
            isClaroPartner, valueSelectInput, mark, cvvValue,
            isValidCvv, valueCardId, openToolTip, isSetDefaultPaymentMethod,
            openHelpTooltipQuery, openHelpTooltipSlice, openHelpTooltipOptions,
            postMessageData,
            isAnonimous,
            cvvFromCardTokenization,
        } = this.state
        const configPayMethodInput = inputConfigValues.find(perro => perro.id === "cardId")
        const configCvvInput = inputConfigValues.find(perro => perro.id === "cvv")
        const currentServiceConfig = this.getCurrentMicroappItemConfig()
        const cvvIsVisible = commissionRules && !this.state.isAnonimous ? commissionRules[0].payProcessor.showCVV : false
        const selectItemValues = {
            input: configPayMethodInput,
            handleInputButtonFunction: this.handleClickSelect,
            value: valueSelectInput,
            mark: mark,
            isClaroPartner: isClaroPartner,
            withClaroInputField: "30%"
        };
        const CvvItemValues = {
            input: configCvvInput,
            handleInputChange: this.handleCvvInputChange,
            value: cvvValue,
            handleClickTooltip: this.handleClickTooltip,
            serviceName: currentServiceConfig.info.serviceName,
            isValid: isValidCvv,
            visible: valueCardId === CREDIT_CLARO_PAY || cvvFromCardTokenization ? false : cvvIsVisible,
            isClaroPartner: isClaroPartner,
        };
        const pendingAmount = telcelPendingAmount
        if(isSetDefaultPaymentMethod){
            this.setDefaultPaymentMethod();
            this.setState({isSetDefaultPaymentMethod: false})
        }
        const cardList = paymentMethods ? paymentMethods.cardList : [];
        const hasN2 = paymentMethods ? paymentMethods.hasN2 : false;
        const isCreditPay = paymentMethods ? paymentMethods.isCreditPay : false;
        const ButtonPayValidate = (cvvIsVisible && isValidCvv)
            || valueCardId === CREDIT_CLARO_PAY
            || valueCardId === "claro-pay"
            || (isAnonimous && !cvvIsVisible) 
            || valueCardId === ADVANCEMENT_CLARO_PAY
        const iframeHeight = postMessageData.mensaje === "exito" ? 
            "52vh": postMessageData.mensaje === "vacio" ? "30.9vh":"52vh"
        const showDomicliationButton = this.showDomiciliationButton(currentServiceConfig)
        const showMorePackagesButton = this.showMorePackagesButton(currentServiceConfig)
        console.log("state: ", this.state)
        console.log("props: ", this.props)
        return (
            <>
                <Container background={isContainerTelcel && !isClaroPartner ? "#f6f6f6" : undefined} withTokenization={this.state.showTokenizationCard}>
                    {
                        
                        <>
                            {
                                !isContainerTelcel 
                                ?
                                <div style={{ textAlign: "center" }}>
                                    <img src={mainLogo.base64} alt="Logo" width={"20%"} />
                                </div>
                                :
                                <></>
                            }
                            {
                                (!this.props.lineTelcelInformation.prepago) || 
                                (this.props.lineTelcelInformation.prepago && isContainerTelcel && !isClaroPartner) 
                                ?                                    
                                    isAnonimous 
                                    ? 
                                        <Title 
                                            align={"center"}
                                            fontFamily={isContainerTelcel && !isClaroPartner ? "AMX-Regular" : undefined}
                                            fontSize={isContainerTelcel && !isClaroPartner ? "14px" : undefined}
                                            color={isContainerTelcel && !isClaroPartner ? "#222222" : undefined}
                                            margin="0px 15px 0px 0px">
                                            {"Tu número celular es:"}
                                            &nbsp;&nbsp;&nbsp;
                                            <Span 
                                                fontFamily={isContainerTelcel && !isClaroPartner ? "AMX-Bold" : undefined}
                                                size={isContainerTelcel && !isClaroPartner ? "18px" : undefined}
                                                color={isContainerTelcel && !isClaroPartner ? "#222222" : undefined}
                                                style={ isAnonimous ? {position: "relative", top: "1px"} : {}}>
                                                {lineNumber}
                                            </Span>
                                        </Title>
                                    :
                                        <Title 
                                            align={"center"}
                                            fontFamily={isContainerTelcel && !isClaroPartner ? "AMX-Regular" : undefined}
                                            color={isContainerTelcel && !isClaroPartner ? "#222222" : undefined}>
                                            {"Tu número celular es: "}
                                            <Span 
                                                weight={!isContainerTelcel ? "bold" : "normal"}
                                                fontFamily={isContainerTelcel && !isClaroPartner ? "AMX-Bold" : undefined}
                                                color={isContainerTelcel && !isClaroPartner ? "#222222" : undefined}>
                                                {lineNumber}
                                            </Span>
                                        </Title> 
                                : 
                                    null
                            }

                            {/****************************
                                Cambios para contenedor 
                            *****************************/}

                            {
                                isContainerTelcel && !isClaroPartner && (postpago || mixto)
                                ?
                                <CardInfoTelcel
                                    background="#ffffff"
                                    borderRadius="8px"
                                    boxShadow="0px 1.9px 1.9px 0px rgba(0,0,0,0.24), 0px 1.9px 1.9px 0px rgba(0,0,0,0.12)"
                                    padding="3% 2% 10px 2%">
                                    <DetailPospagoItem
                                        margin="15px 8px 15px 8px"
                                        padding="0px 0px 23px 0px"
                                        borderBottom="1px solid #bac9d8">
                                            <Span
                                                weight="normal"
                                                fontFamily="AMX-Regular"
                                                size="14px"
                                                color="#222222">
                                                Total a pagar:
                                            </Span>
                                            <Span
                                                fontFamily="AMX-Bold"
                                                size="18px"
                                                color="#008000"
                                                style={{ position: "relative", top: "2px", left: "7px" }}>
                                                {formatCurrency.format(telcelPendingAmount)}                                                    
                                            </Span>
                                            <button 
                                                style={{
                                                    background: ButtonPayValidate ? "#7b1fa2" : "#d0d0d0",
                                                    color: ButtonPayValidate ? "#ffffff" : "#595959",
                                                    padding: "8px 38px 8px 38px",
                                                    margin: "-8px 0px 0px 0px",
                                                    fontFamily: "AMX-Bold",
                                                    fontSize: "16px",
                                                    border: "0px",
                                                    borderRadius: "18px",
                                                    width: "auto",
                                                    maxWidth: "117px",
                                                    lineHeight: "24px",
                                                    float: "right"
                                                }}
                                                onClick={() => this.onSubmit()}
                                                disabled={!ButtonPayValidate}>
                                                Pagar
                                            </button>                                           
                                                                                        
                                    </DetailPospagoItem>
                                    {
                                        (!isAnonimous || this.props.addCardFormData.handleSetDefaultPaymentMethod) &&
                                        <>
                                            <DetailPospagoItem
                                                margin={!isAnonimous && paymentMethods.hasN2 ? "0px 8px 8px 8px" : "0px 8px"}
                                                padding="0px"
                                                borderBottom={CvvItemValues.visible ? "1px solid #bac9d8" : "none"}>
                                                <SelectInputTelcelContainer {...selectItemValues}  />
                                                
                                            </DetailPospagoItem>
                                            <DetailPospagoItem
                                                margin="0px 8px"
                                                padding="0px"
                                                borderBottom={CvvItemValues.visible ? "1px solid #bac9d8" : "none"}>
                                                <CvvInputTelcelContainer 
                                                    {...CvvItemValues} 
                                                    serviceId={currentServiceConfig.info.serviceId} />
                                            </DetailPospagoItem>
                                        </>
                                    } 
                                    <ButtonsGridContainer isContainerTelcel={isContainerTelcel} cvvIsVisible={CvvItemValues.visible} showDomicliationButton={showDomicliationButton}>
                                        {showDomicliationButton &&
                                            <div>
                                                <SchedulePaymentButton
                                                    hasNIP={paymentMethods.hasNIP}
                                                    hasN2={hasN2}
                                                    history={history}
                                                    lineNumber={lineNumber}
                                                    serviceId={currentServiceConfig.info.serviceId}
                                                    amount = {'10'}
                                                    tagServiceId = {tagServiceId}
                                                    isContainerTelcel={isContainerTelcel}
                                                />
                                            </div>
                                        }
                                        <ButtonMiTelcelContenedorWhite 
                                            active={ButtonPayValidate} 
                                            disabled={this.state.isAnonimous ? false : !ButtonPayValidate} 
                                            onClick={
                                                () => this.handleBuyPackages(
                                                    null, 
                                                    null, 
                                                    true, 
                                                    ButtonPayValidate, 
                                                    false, 
                                                    (postpago ? OFFER_TELCEL_PAQUETE_POSPAGO_EVENTUAL : OFFER_TELCEL_PAQUETE_POSPAGO_MIXTO)
                                                )
                                            }>
                                            Quiero más datos
                                        </ButtonMiTelcelContenedorWhite>
                                    </ButtonsGridContainer>                                       
                                </CardInfoTelcel>
                                :
                                <></>
                            }
                            <CardInfoTelcel
                                background={isContainerTelcel && !isClaroPartner ? "#ffffff" : undefined}
                                borderRadius={isContainerTelcel && !isClaroPartner ? "8px" : undefined}
                                boxShadow={isContainerTelcel && !isClaroPartner ? "0px 1.9px 1.9px 0px rgba(0,0,0,0.24), 0px 1.9px 1.9px 0px rgba(0,0,0,0.12)" : undefined}>
                                <>
                                    <div className=''>
                                        {
                                                urlIframe && <iframe
                                                src={`${urlIframe}?msisdn=${lineNumber}`}
                                                id="frameTelcel"
                                                style={{ 
                                                    border: "none", 
                                                    height: !isContainerTelcel ? iframeHeight : "350px", 
                                                    width: "100%", 
                                                }}
                                                scrolling='yes'
                                            >
                                                "No es posible visualizar el contenido"
                                            </iframe>
                                        }
                                    </div>
                                    
                                </>
                                {
                                    !isContainerTelcel ?
                                    <>
                                        {
                                            postpago || mixto  ?
                                                <Title>{"Total a pagar de tu plan: "}
                                                    <Span weight={"bold"} color={"#7ea549"}>{formatCurrency.format(pendingAmount)}</Span>
                                                </Title> : <></>
                                        }
                                        <SelectInputClaroSocio {...selectItemValues} />
                                        <CvvInputClaroSocio {...CvvItemValues} serviceId={currentServiceConfig.info.serviceId} />
                                        {
                                            postpago || mixto
                                                ? <>
                                                    <div>
                                                        <ButtonMiTelcel
                                                            height={"3.5em"}
                                                            backgroundColor="#000000"
                                                            margin={"0px auto"}
                                                            onClick={() => this.onSubmit()}
                                                            isEnabled={ButtonPayValidate}
                                                            disabled={!ButtonPayValidate}
                                                            width={"100%"}
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "center"
                                                            }}>
                                                            {"Pagar " + formatCurrency.format(pendingAmount)}
                                                        </ButtonMiTelcel>
                                                    </div>           
                                                    <ButtonsContentPospagoGridContainer showDomicliationButton={showDomicliationButton} showMorePackagesButton={showMorePackagesButton}>
                                                        <>
                                                        {
                                                            showDomicliationButton? 
                                                            <div>
                                                                <SchedulePaymentButton
                                                                    hasNIP={paymentMethods.hasNIP}
                                                                    hasN2={hasN2}
                                                                    history={history}
                                                                    lineNumber={lineNumber}
                                                                    serviceId={currentServiceConfig.info.serviceId}
                                                                    amount = {pendingAmount}
                                                                    tagServiceId = {tagServiceId}
                                                                />
                                                            </div>
                                                            :
                                                            null
                                                        }
                                                        </>
                                                        <>
                                                        {
                                                            showMorePackagesButton && postpago ?
                                                            <div>
                                                                <ButtonMiTelcel
                                                                    height={"3.5em"}
                                                                    backgroundColor="#fff"
                                                                    margin={"0px auto"}
                                                                    width={"-webkit-fill-available"}
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        background: true ? "#fff" : "#ccc",
                                                                        color: true ? "#000" : "#999",
                                                                        border: true ? "1px solid black" : "1px solid #ccc",
                                                                    }}
                                                                    onClick={
                                                                        (e) => this.openAction(
                                                                            e, 
                                                                            this.state.configPospago && this.state.configPospago.serviceData && this.state.configPospago.serviceData.moreData?
                                                                            this.state.configPospago.serviceData.moreData.taggeoAction : "", 
                                                                            this.state.configPospago && this.state.configPospago.serviceData && this.state.configPospago.serviceData.moreData?
                                                                            this.state.configPospago.serviceData.moreData.typeOffer :"", 
                                                                            this.state.configPospago && this.state.configPospago.serviceData && this.state.configPospago.serviceData.moreData?
                                                                            this.state.configPospago.serviceData.moreData.typeEvent :"",
                                                                            this.state.configPospago && this.state.configPospago.serviceData && this.state.configPospago.serviceData.moreData?
                                                                            this.state.configPospago.serviceData.moreData.microAppId :"",
                                                                        )
                                                                    }
                                                                >
                                                                    Quiero más datos
                                                                </ButtonMiTelcel>
                                                            </div>
                                                            :
                                                            null
                                                        }
                                                        {
                                                            isActiveButtonMoreDataMix && mixto 
                                                                ?
                                                                    <>
                                                                        <ButtonMiTelcel 
                                                                            style={{
                                                                                background: ButtonPayValidate ? "#fff" : "#ccc",
                                                                                color: ButtonPayValidate ? "#000" : "#999",
                                                                                border: ButtonPayValidate ? "1px solid black" : "1px solid #ccc",
                                                                            }} 
                                                                            disabled={!ButtonPayValidate} 
                                                                            onClick={
                                                                                () => this.handleBuyPackages(
                                                                                    null, 
                                                                                    null, 
                                                                                    true, 
                                                                                    ButtonPayValidate, 
                                                                                    false, 
                                                                                    OFFER_TELCEL_PAQUETE_POSPAGO_MIXTO
                                                                                )
                                                                            }>
                                                                            Quiero más datos
                                                                        </ButtonMiTelcel>
                                                                    </>
                                                                :
                                                                <></>
                                                        }
                                                        </>
                                                    </ButtonsContentPospagoGridContainer>
                                                    
                                                    </>
                                                : <ButtonMiTelcel
                                                    height={"3.5em"}
                                                    backgroundColor="#000000"
                                                    margin={"6% auto 0%"}
                                                    display={"block"}
                                                    onClick={() => this.handleBuyPackages("Click Comprar paquetes", "Prepago", true, true)}
                                                    isEnabled={ButtonPayValidate}
                                                    disabled={!ButtonPayValidate}
                                                    width={"60%"}
                                                >
                                                    {"Comprar paquetes"}
                                                </ButtonMiTelcel>
                                        }
                                    </>
                                    :
                                    <>
                                        {
                                            prepago 
                                            ?
                                            <>              
                                                <center>
                                                    <div style={{ width: "95%", textAlign: "center" }}>
                                                        <button 
                                                            style={{
                                                                border: "0px",
                                                                background: ButtonPayValidate ? "#7b1fa2" : "#d0d0d0",
                                                                color: ButtonPayValidate ? "#ffffff" : "#595959",
                                                                padding: "8px 10px 8px 10px",
                                                                margin: !isAnonimous ? "15px 0px 27px 0px" : "15px 0px 0px 0px",
                                                                fontFamily: "AMX-Bold",
                                                                fontSize: "16px",
                                                                borderRadius: "38px",
                                                                width: "100%",
                                                                lineHeight: "24px",
                                                            }}
                                                            onClick={() => this.handleBuyPackages("Click Quiero más datos", "Prepago", true, true)}
                                                            disabled={!ButtonPayValidate}>
                                                            Comprar paquetes
                                                        </button> 
                                                        {
                                                            (!isAnonimous || this.props.addCardFormData.handleSetDefaultPaymentMethod) &&
                                                            <>
                                                                <hr style={{ border: "0px", borderTop: "1px solid #bac9d8",  margin: "20px 0px 0px 0px" }} />
                                                                <DetailPospagoItem
                                                                    margin="0px 0px"
                                                                    padding="0px"
                                                                    borderBottom={CvvItemValues.visible ? "1px solid #bac9d8" : "none"}>
                                                                    <SelectInputTelcelContainer {...selectItemValues}  />
                                                                    
                                                                </DetailPospagoItem>
                                                                <DetailPospagoItem
                                                                    margin="0px 0px"
                                                                    padding="0px"
                                                                    borderBottom={"none"}>
                                                                    <CvvInputTelcelContainer 
                                                                        {...CvvItemValues} 
                                                                        serviceId={currentServiceConfig.info.serviceId} />
                                                                </DetailPospagoItem>   
                                                            </>
                                                        }                                                                            
                                                    </div>    
                                                </center>
                                            </>
                                            :
                                            <>                                                 
                                            </>
                                        }                                             
                                    </>
                                }
                                
                            </CardInfoTelcel>
                        </>
                         
                    }

                    {/* Opción para adelanta megas */}
                    <>
                        {
                            this.props.canAdvanceMegas &&
                            isContainerTelcel &&
                            userInfo.advance &&
                            userInfo.advance.available &&
                            userInfo.advance.banners &&
                            userInfo.advance.banners.web &&
                            <AdvanceMegas />
                        }
                    </>

                    {/* Opción para recurrente */}
                    <>
                        {
                            isContainerTelcel && 
                            phoneProfile && 
                            phoneProfile.data &&
                            phoneProfile.data.hasRecurrent && 
                                <CardInfoTelcel
                                    background="#ffffff"
                                    borderRadius="16px"
                                    boxShadow="0px 2px 4px rgba(0, 0, 0, 0.08)"
                                    padding="16px" 
                                    width="calc(94% - 32px)"                               
                                >
                                        <ContainerRecurrent onClick={(e) => this.openSuscripciones(e)}>
                                            <img 
                                                src={`${process.env.REACT_APP_IMAGES}icon-megas-package.svg`} 
                                                className='icon-package' 
                                            />

                                            <div>
                                                <p className='title'>
                                                    Tienes una recurrencia activa
                                                </p>
                                                <p className='content'>
                                                    Gestiona tu paquete con cargo a factura
                                                </p>
                                            </div>

                                            <img 
                                                src={`${process.env.REACT_APP_IMAGES}icon-megas-arrow.svg`} 
                                                className='icon-arrow' 
                                            />
                                        </ContainerRecurrent>                                    
                                </CardInfoTelcel>
                        }
                    </>

                    {/* Banners Megas Telcel */}
                    {
                        isContainerTelcel 
                            ? 
                                <CarouselMegasTelcel 
                                    origin="MiTelcel" 
                                    margin="10px 3% 0px 3%"
                                    marginBottom="-5px"
                                    handleBannerClick={(evt,imageURL) => {
                                        if (
                                            this.props && 
                                            this.props.lineTelcelInformation
                                        ) {
                                            const { prepago, postpago } = this.props.lineTelcelInformation;
                                            const planType = prepago ? "Prepago" : "Pospago";
                                            if (prepago || postpago) {
                                                this.props.executeTaggeo({
                                                    eventName: "telcel",
                                                    step: "Pantalla principal",
                                                    action: "Click banner",
                                                    banner_id: imageURL ? imageURL:"",
                                                    plan_type: planType
                                                });
                                            }
                                        }                                        
                                    }}
                                    handleInputClick={() => false} /> 
                            : 
                                <></>
                    }

                    <OfferTelcelWithoutLine
                        isClaroPartner={isClaroPartner}
                        isContainerTelcel={isContainerTelcel}
                        offerTelcel={!isAnonimous ? currentServiceConfig.offerTelcel : currentServiceConfig.offerTelcelAnonimo}
                        planType={postpago ? "Pospago" : "Prepago"}
                        history={history}
                        subtitleAlign={"left"}
                        subtitleMargin={"5% 0% 2% 5%"}
                        logoIsVisible={"none"}
                        subtitle={"Elige una opción"}
                    />
                </Container>
                <SelectCardClaroSocio
                    backgroundColor="rgba(0,0,0,0.8)"
                    isOpen={
                        !isLoadingGetPaymentMethods && openSelectCard
                    }
                    colorButton="#797878"
                    height="70%"
                    marginButton="0px 0px 0px 10px"
                    fontSizeButton="23px!important"
                    fadeInTime="1s"
                    cubicBezier="cubic-bezier(0.9, 0, 0.9, 1)"
                    fadeIn
                    addCloseEfect={false}
                    cardItems={cardList}
                    hasN2={hasN2}
                    closeSelectCardClaroSocio={() => this.setState({ openSelectCard: false })}
                    handleInputClick={this.handleInputClick}
                    selectValue={valueCardId}
                    showAdvancementPayMethodInList={getRequirementsAdvancementClaroPay(
                        userInfo, isContainerTelcel, currentServiceConfig.info.serviceId, tagServiceId, prepago
                    )}
                    activeN2={this.validateActiveN2()}
                    isCreditPay={isCreditPay}
                    isClaroPartner={isClaroPartner}
                    isContainerTelcel={isContainerTelcel}
                    executeTaggeo={this.props.executeTaggeo}
                />
                <SelectCardAnonimous 
					height="75%"
					backgroundColor="rgba(0,0,0,0.1)"
					isOpen={
						this.state.openSelectCardAnonimous
					}
                    isContainerTelcel={isContainerTelcel}
					fadeInTime="1s"
					cubicBezier="cubic-bezier(0.9, 0, 0.9, 1)"
					fadeIn
					addCloseEfect={false}
					handleCloseSelectCardAnonimous={() => {
                        console.log("BP2")
                        this.setState({ openSelectCardAnonimous: false })}
                    }
					handleInputClick={this.handleInputClick}
					handleOpenModalCardHE={() => this.setState({isOpenModalCardHE: true})}
                    setAddCardFormDataHandler={() => {
                        this.setAddCardFormDataHandler();
                    }}
                    closeTokenizationCard={this.closeTokenizationCard}
				/>
                <ModalCardHE 
					isOpen={this.state.isOpenModalCardHE}
					close={()=>this.setState({isOpenModalCardHE: false})}
				/>
                <ClaroTooltip
                    closeImg={isContainerTelcel ? `${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}icono_salir_contenedor.png` : undefined}
                    fontFamilyTitle={isContainerTelcel ? "AMX-Bold" : undefined}
                    fontFamilySubtitle={isContainerTelcel ? "AMX-Regular" : undefined}
                    isOpen={openToolTip}
                    addCloseEfect={false}
                    onclickCloseTooltip={() => this.setState({ openToolTip: false })}
                    text={"Tarjeta Visa y Master Card"}
                    srcImage={isContainerTelcel ? "/images/cvv.png" : "/images/cvv.svg"}
                    heightImg={validateUserAgent() === "android" ? "43%" : "38%"}
                    colorButton="#797878"
                    fontSizeTitle={isContainerTelcel ? "18px" : "15px"}
                    height={"58%"}
                    colorTitle={isContainerTelcel ? "#000000" : "#161616"}
                    fontSizeButton="23px!important"
                    fadeInTime="1s"
                    fadeIn
                    cubicBezier="cubic-bezier(0.9, 0, 0.9, 1)"
                    widthImg="272px"
                    textSubtitle={"El número de tres dígitos ubicado en el reverso de tu tarjeta de crédito o débito."}
                    colorSubtitle={isContainerTelcel ? "#000000" : "#838383"}
                    fontWeightTitle="bold!important"
                    fontWeightSubtitle="normal!important"
                    fontSizeSubtitle="12px"
                    paddingTitle="3px 16px 0px 16px"
                    marginTitle={isContainerTelcel ? "0px 0px 15px 0px" : undefined}
                    marginButton="0px 0px 0px 0px"
                    boxShadow="none"
                />
                <ToolTipMiTelcel 
                    isContainerTelcel={isContainerTelcel}
                    tooltipInformation={!isContainerTelcel ? getMessage(messages, "CP0002", "MiniAppTelcel") : getMessage(messages, "CP0025", "MiniAppTelcel")} 
                    isOpen={openHelpTooltipQuery}
                    handleCloseHelpTooltip={
                        () => this.setState({openHelpTooltipQuery: false})
                    }
                    handleNextAction={
                        () => this.handleNextAction("openHelpTooltipQuery")
                    }
                    handleDontShowAgain={
                        () => this.handleDontShowAgain("openHelpTooltipQuery")
                    }
                />
                <ToolTipMiTelcel 
                    isContainerTelcel={isContainerTelcel}
                    tooltipInformation={!isContainerTelcel ? getMessage(messages, "CP0003", "MiniAppTelcel") : getMessage(messages, "CP0027", "MiniAppTelcel")} 
                    isOpen={openHelpTooltipSlice}
                    handleCloseHelpTooltip={
                        () => this.setState({openHelpTooltipSlice: false})
                    }
                    handleNextAction={
                        () => this.handleNextAction("openHelpTooltipSlice")
                    }
                    handleDontShowAgain={
                        () => this.handleDontShowAgain("openHelpTooltipSlice")
                    }
                />
                <ToolTipMiTelcel 
                    isContainerTelcel={isContainerTelcel}
                    tooltipInformation={!isContainerTelcel ? getMessage(messages, "CP0004", "MiniAppTelcel") : getMessage(messages, "CP0026", "MiniAppTelcel")} 
                    isOpen={openHelpTooltipOptions}
                    handleCloseHelpTooltip={
                        () => this.setState({openHelpTooltipOptions: false})
                    }
                    handleNextAction={
                        () => this.handleNextAction("openHelpTooltipOptions")
                    }
                    handleDontShowAgain={
                        () => this.handleDontShowAgain("openHelpTooltipOptions")
                    }
                />
                <ModalCardLoader isOpen={loadingTokenizationCard} />
                <ModalCardOk
					isOpen={this.state.openModalUpdateCard}
					srcImage="data:image/png;base64,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"
					text="¡Hey!"
					buttontext="Actualizar ahora"
					textdetail="Es necesario que actualices los datos de esta tarjeta para que puedas utilizarla"
					onclickModal={this.onclickUpdateCard}
					textLink="Hacerlo en otro momento"
					textDecorationLinkButton="underline"
					fontFamilyTitle='AMX-Bold' 
					colorTextModal1={isContainerTelcel ? '#222222' : undefined}
					fontFamilyTextdetail={isContainerTelcel ? "AMX-Regular" : undefined}
					fontSizeTitle={isContainerTelcel ? '20px' : '26px'}
					backgroundColorButton={isContainerTelcel ? '#7b1fa2' : undefined}
					fontFamilyButton= 'AMX-Bold' 
					fontSizeButton={isContainerTelcel ? '16px' : '4.05vw '}
					marginButton={isContainerTelcel ? "0 auto 28px auto" : undefined}
					fontSizeDetail={isContainerTelcel ? "16px" : "12px"}
					colorTextdetail={isContainerTelcel ? "#757575" : undefined}
					textSizeLinkButton={isContainerTelcel ? "16px" : "10px"}
					fontFamilyLinkButton='AMX-Bold' 
					textColorLinkButton={isContainerTelcel ? "#0071d1" : "#000"}
					marginTitle={isContainerTelcel ? "0px 0px 20px 0px" : undefined}
					marginTextDetail={isContainerTelcel ? "0px 0px 30px 0px" : undefined}
				/>
                <>{
                    this.state.showTokenizationCard
                    && <TokenizationCardContainer
                        {...this.props}
                        closeTokenizationCard={this.closeTokenizationCard}
                        updateCard={this.state.updateWithTokenization}
                    />
                }</>
                <>{
                    this.state.showModalRecurrent
                    && <ModalRecurrente
                        handleOnClick={() => this.setState({ showModalRecurrent : false })}
                        {...this.props}
                        isContainerTelcel={isContainerTelcel}
                    />
                }</>
            </>
        )
    }
}

function mapStateToProps(state) {
    const {
        lineTelcelInformation,
        userInfo,
        paymentMethods,
        cardInfo,
        activeN2,
        commissionRules,
        trackId,
        messages,
        isAnonimous,
        addCardFormData,
        lineNumber,
        startEventOnboardingIsOver,
        amountTelcelPospago,
        PAYMENT_SERVICE_CONF,
        phoneProfile,
        canAdvanceMegas,
        originParamValue,
    } = state.payments;
    return {
        paymentsConfig: selectPaymentServiceConf(state.payments),
        userInfo,
        lineTelcelInformation,
        paymentMethods,
        creditCardInfo: cardInfo,
        activeN2,
        commissionRules,
        trackId,
        messages,
        isAnonimous,
        addCardFormData,
        referenceFromUrl: lineNumber,
        telcelPendingAmount : amountTelcelPospago ? getPendingAmount(amountTelcelPospago) : 0,
        paymentStore : state.payments,
        startEventOnboardingIsOver,
        isActiveButtonMoreDataMix: PAYMENT_SERVICE_CONF.isActiveButtonMoreDataMix,
        tokenizationCard: getTokenizationCardSelector(state),
        tokenizationOn: getTokenizationOnSelector(state),
        canRegisterEmail: getCanRegisterEmailSelector(state),
        loadingTokenizationCard: getLoadingTokenizationCardSelector(state),
        phoneProfile,
        canAdvanceMegas,
        originParamValue,
    };

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            getAmountOfTelcelPospago,
            executeTaggeo,
            getPaymentMethods,
            setCreditCardInfo,
            getCommissionInfo,
            getMessengerService,
            getHasDomiciliation,
            setStartEventOnboardingIsOver,
            setTokenizationCard,
			setSnackBarSuccess,
			setLoadingTokenizationCard,
            getPhoneProfile,
        },
        dispatch,
    );
}

OfferTelcelWithLine = connect(
    mapStateToProps,
    mapDispatchToProps
)(OfferTelcelWithLine);

export default OfferTelcelWithLine